module.exports = __webpack_public_path__ + "38abe80e0cb9775bea8ca0a9fd1d216c.svg";